




























import Component from "vue-class-component";
import TestingStep1 from "@/components/lfs/Testing/Step1.vue";
import TestingStep2 from "@/components/lfs/Testing/Step2.vue";
import TestingStep3 from "@/components/lfs/Testing/Step3.vue";
import TestingStep4 from "@/components/lfs/Testing/Step4.vue";
import TestingStep5 from "@/components/lfs/Testing/Step5.vue";
import TestingStep6 from "@/components/lfs/Testing/Step6.vue";
import TestingStep7 from "@/components/lfs/Testing/Step7.vue";
import Vue from "vue";
import {mapGetters, mapActions} from "vuex";

type TStepperInfo = {
  step: number,
  title: string,
  info: string
}

@Component({
  name: "testing-stepper",
  components: {
    TestingStep1, TestingStep2, TestingStep3, TestingStep4, TestingStep5, TestingStep6, TestingStep7
  },
  computed: {
    ...mapActions({
      setStep: "testing/step",
      stopDemo: "testing/stop"
    }),
    ...mapGetters({
      step: "testing/step"
    })
  }
})
export default class TestingStepper extends Vue{

  private emptyStep:TStepperInfo = { step:0, title: '', info: ''}

  protected data: Array<TStepperInfo> = [
    {
      step: 1,
      title: 'Скачайте приложение',
      info: 'Наше приложение доступно в AppStore и Google Play или вы можете скачать установочный файл с нашего сайта по QR-коду',
    },
    {
      step: 2,
      title: 'Зарегистрируйтесь в приложении',
      info: 'Отсканируйте штрихкод или введите цифры вручную из окна ниже',
    },
    {
      step: 3,
      title: 'Сканируйте бейджи посетителей и участников, а так же QR-коды стендов и продукции',
      info: '',
    },
    {
      step: 4,
      title: 'Посмотреть собранные данные и выгрузить на почту',
      info: '',
    },
    {
      step: 5,
      title: 'Посмотреть статистику',
      info: '',
    },
    {
      step: 6,
      title: 'Настроить анкету. Изменить данные на своих бейджах. Изменить данные на стенде',
      info: '',
    },
    {
      step: 7,
      title: 'Завершить демо-тур и удалить тестовые данные',
      info: '',
    },
  ]

  getTitle(step: number): string {
    const info = this.data.find(info => info.step === step) || this.emptyStep;
    return info.title
  }

  getInfo(step: number): string {
    const info = this.data.find(info => info.step === step) || this.emptyStep;
    return info.info
  }
}
